import { render, staticRenderFns } from "./TextMessageChannel.vue?vue&type=template&id=a293d530&scoped=true&lang=html"
import script from "./TextMessageChannel.vue?vue&type=script&lang=js"
export * from "./TextMessageChannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a293d530",
  null
  
)

export default component.exports